<template>
  <div>
    <!-- Render the appropriate version with banner prop -->
    <component :is="currentVersion" :key="componentKey" :show-banner="true"/>
  </div>
</template>

<script>
import CreateAppointmentV2 from './CreateAppointmentV2.vue';
import {getFeatureFlag} from '../../utils/featureFlags';

export default {
  name: 'CreateAppointment',
  components: {
    // CreateAppointmentV1,
    CreateAppointmentV2
  },
  data() {
    return {
      componentKey: 0,
      storageEventHandler: null
    };
  },
  computed: {
    useV2() {
      return getFeatureFlag('useAppointmentV2', true);
    },
    currentVersion() {
      // return this.useV2 ? 'CreateAppointmentV2' : 'CreateAppointmentV1';
      return 'CreateAppointmentV2'; // V1 component removed
    }
  },
  methods: {
    handleStorageChange(e) {
      // Listen for localStorage changes (from the banner component)
      if (e.key === 'useAppointmentV2' || e.storageArea === localStorage) {
        // Force component reload
        this.componentKey++;
      }
    },
    setupStorageListener() {
      // Custom event listener for same-window storage changes
      // (since storage event doesn't fire in the same window by default)
      this.storageEventHandler = () => {
        this.componentKey++;
      };

      window.addEventListener('appointmentVersionChanged', this.storageEventHandler);
      window.addEventListener('storage', this.handleStorageChange);
    }
  },
  mounted() {
    this.setupStorageListener();
  },
  beforeDestroy() {
    if (this.storageEventHandler) {
      window.removeEventListener('appointmentVersionChanged', this.storageEventHandler);
      window.removeEventListener('storage', this.handleStorageChange);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/appointments/CreateAppointment.vue